import gsap from "gsap";
import tippy from 'tippy.js';

export default function(){
	const infoBlock1  = document.querySelector( '.eligibility-calculator__block-1 > div' )
	const infoBlock2  = document.querySelector( '.eligibility-calculator__block-2' )
	const form        = document.getElementById('eligibility-calculator-form');
	const formWrapper = document.querySelector( '.form-wrapper' )
	const results     = document.getElementById('results');
	const messages    = results?.querySelectorAll('.message');

	function hideAllMessages(){
		messages.forEach(message => {
			message.classList.add('hidden')
		});
	}

	if ( form ){
		// Starting point
		gsap.set( results, { height: 0, autoAlpha: 0 } )
		hideAllMessages()

		if ( window.innerWidth > 827 ){
			infoBlock1.style.paddingBottom = formWrapper.clientHeight + 100 + 'px'
			infoBlock2.style.paddingBottom = formWrapper.clientHeight + 100 + 'px'
			formWrapper.style.marginTop    = - formWrapper.clientHeight - 40 + 'px'
		}

		// END Starting point

		form.addEventListener('submit', e => {
			e.preventDefault();
			hideAllMessages()

			const income     = form.querySelector('#income').value;
			const savings    = form.querySelector('#savings').value;
			const meals      = form.querySelector('#meal-option').value;

			let messageShown = false;

			gsap.set( results, { height: 'auto', autoAlpha: 1 } )

			// Income <£30,000 - Savings <£5,000 - FSM YES
			if ( income < 30000 && savings < 5000 & meals === 'yes' ) {
				document.querySelector( '.message.message--1' ).classList.remove('hidden')
				messageShown = true
			}
			// Income £30,000 - £59,999 - Savings <£5,000 - FSM YES & NO
			if ( income >= 30000 && income <= 59999 && savings < 5000) {
				document.querySelector( '.message.message--2' ).classList.remove('hidden')
				messageShown = true
			}
			// Income £60,000 - £100,000 - Savings <£10,000 - FSM NO
			if (income >= 60000 && income <= 100000 && savings < 10000 && meals === 'no') {
				document.querySelector( '.message.message--3' ).classList.remove('hidden')
				messageShown = true
			}
			// Income £100,000 - £150,000 - Savings <£20,000
			if (income >= 100000 && income <= 150000 && savings < 20000) {
				document.querySelector( '.message.message--4' ).classList.remove('hidden')
				messageShown = true
			}
			// Income £150,000 - Savings <£50,000
			if (income >= 150000 && savings < 50000) {
				document.querySelector( '.message.message--5' ).classList.remove('hidden')
				messageShown = true
			}
			// Income £150,000 - Savings >£50,000
			if (income >= 150000 && savings >= 50000) {
				document.querySelector( '.message.message--6' ).classList.remove('hidden')
				messageShown = true
			}

			if ( ! messageShown ){
				document.querySelector( '.message.message--default' ).classList.remove('hidden')
			}
		})

		// TOLTIPS
		const tooltips = form.querySelectorAll('span[js-title]')

		if ( tooltips.length > 0 ){
			tooltips.forEach(tooltip => {
				tippy(tooltip, {
					content: tooltip.getAttribute('js-title'),
					theme: 'light',
				});
			});
		}
		
	}
}